export default "https://cdn-static.gokick.com/assets/f782299a76cdb7f85e2c64a970a00c34ce21ab93/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";